import React from "react";
import { Button } from "components";
import QuestionCard from "elements/QuestionCard";
import { useExemptionsContext } from "../../ExemptionsContext";
import { useEventTracker } from "utils/useEventTracker";
import constants from "utils/constants";
import { usePropertyContext } from "../../context";
import {
	prefixIndefiniteArticle,
	stateSpecificExemptionWord,
} from "utils/account";
import ButtonV2 from "elements/ButtonV2";

const currentYear = new Date().getFullYear();

export const PrimaryResidenceQuestionCopy = `Will this be your primary residence in ${currentYear}?`;
export const PrimaryResidenceQuestionSubTitle = (state?: string) => {
	return `You can only qualify for ${prefixIndefiniteArticle(
		stateSpecificExemptionWord(state)
	)} if you occupied this address as your primary residence as of January 1st this year.`;
};

const PrimaryResidence = () => {
	const { flowId, primaryResidenceValue, setPrimaryResidenceValue, next } =
		useExemptionsContext();
	const { details } = usePropertyContext();
	const trackEvent = useEventTracker();

	const primaryResidenceValueToUse = React.useMemo(() => {
		if (primaryResidenceValue !== undefined) {
			return primaryResidenceValue;
		} else if (details?.q_primary_residence !== undefined) {
			return !!details?.q_primary_residence;
		}
	}, [primaryResidenceValue, details?.q_primary_residence]);

	const handleSubmit = async () => {
		setPrimaryResidenceValue(primaryResidenceValueToUse);
		trackEvent({
			eventName: constants.EVENTS.Exemptions_Flow_Primary_Residence_Answer,
			data: {
				"Primary Residence": primaryResidenceValue ? "Yes" : "No",
				"Is End-To-End Signup": details?.exemption?.is_end_to_end_signup
					? "Yes"
					: "No",
			},
		});
		const trackingEventData = {
			"Primary Residence": primaryResidenceValue ? "Yes" : "No",
		};
		next({ trackingEventData });
	};

	const questionSubTitle = React.useMemo(() => {
		if (flowId === "NEW_YORK_EXEMPTION") {
			return "You can only qualify for a STAR credit if you occupied this address as your primary residence as of January 1st this year.";
		} else {
			return PrimaryResidenceQuestionSubTitle(details?.state);
		}
	}, [flowId]);

	return (
		<form
			onSubmit={e => {
				e.preventDefault();
				handleSubmit();
			}}>
			<QuestionCard
				id="primaryresidence"
				value={primaryResidenceValueToUse}
				setValue={setPrimaryResidenceValue}
				tooltipText=""
				question={PrimaryResidenceQuestionCopy}
				subTitle={questionSubTitle}></QuestionCard>
			{primaryResidenceValue === false && (
				<p className="sm exemptions-notification-message-azure">
					Certain exemptions
					{flowId === "NEW_YORK_EXEMPTION" ? " and credits " : " "}are only
					available for the property if it is your primary residence. Since this
					is not your primary residence we will try to find you opportunities to
					save in other ways!
				</p>
			)}
			<ButtonV2
				size="large"
				disabled={primaryResidenceValueToUse === undefined}
				type="submit">
				Continue
			</ButtonV2>
		</form>
	);
};

export default PrimaryResidence;
